// extracted by mini-css-extract-plugin
module.exports = {"wrap":"y_cj","phone":"y_ck","phone-link":"y_cl","phoneLink":"y_cl"};